module.exports = __webpack_public_path__ + "static/img/wall-conveyor-x3_64.e0564f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wall-conveyor-x3_64.png
// module id = O6mP
// module chunks = 0